import HeroSection from './HeroSection'
import ShippingSolutionsSection from './ShippingSolutionsSection'
import TeamPage from './TeamPage'
// import CoreValues from "./CoreValues";
// import MissionVisionAndServices from "./MissionVisionAndServices";
// import CompanyOverview from "./CompanyOverview";
// import WhyChooseUs from "./WhyChooseUs";
// import Testimonials from "./Testimonials";
// import Certifications from "./Certifications";
// import CallToActionFooter from "./CallToActionFooter";
// import ServicesPage from "./ServicesPage";
import TestimonialSection from './TestimonialSection'
import BusinessSolutions from './BusinessSolutions'
// import Highlights from './Highlights'
import CommitmentProcess from './CommitmentProcess'
import { Helmet } from 'react-helmet-async'
import MoreServicesSection from './MoreServicesSection'
// import FooterCTA from "./FooterCTA";
// import CTA from "./CTA";

const About = () => {
  return (
    <div className='bg-gray-50 text-gray-800'>
      <Helmet>
        <title>
          About Us | S Infinite Express - India's Trusted Logistics Network
        </title>
        <meta
          name='description'
          content='Discover how S Infinite Express is revolutionizing logistics in India through innovation, technology, and a powerful delivery network. Learn more about our team, mission, and services.'
        />
        <meta
          name='keywords'
          content='S Infinite Express, logistics company, freight delivery, courier, warehousing, LTL, PTL, FTL, supply chain India, express logistics'
        />
        <meta name='author' content='S Infinite Express Pvt. Ltd.' />
        <link rel='canonical' href='https://sinfiniteexpress.com/about-us' />
        {/* Open Graph / Social Sharing Tags */}
        <meta property='og:title' content='About Us | S Infinite Express' />
        <meta
          property='og:description'
          content='Learn more about S Infinite Express, India’s fastest-growing logistics company offering reliable PTL, FTL, courier, and warehousing services.'
        />
        <meta
          property='og:url'
          content='https://sinfiniteexpress.com/about-us'
        />
        <meta property='og:type' content='website' />
      </Helmet>

      <HeroSection />
      <ShippingSolutionsSection />
      <MoreServicesSection />
      <CommitmentProcess />
      <BusinessSolutions />
      {/* <Highlights /> */}
      {/* <CoreValues /> */}
      {/* <MissionVisionAndServices /> */}
      {/* <CompanyOverview /> */}
      {/* <ServicesPage /> */}
      {/* <WhyChooseUs /> */}
      <TeamPage />
      {/* <CTA /> */}
      <TestimonialSection />
    </div>
  )
}

export default About
